// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8.5 6C8.5 2.68629 11.1863 0 14.5 0H19V6H16C15.1716 6 14.5 6.67157 14.5 7.5V9H19.2808L17.7808 15H14.5V24H8.5V15H4.25V9H8.5V6Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-facebook-filled')
export default class LogoFacebookFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-facebook-filled',
    }
  }
}
